import React from 'react';
import { Box } from '@mui/material';

// Register-only regulations (AB#17116 AC4): one card per regulation the instance
// has in-scope assets for that we do not measure obligations against. The reason
// line differs by card (rule-defines-nothing vs not-yet-assessed) and the cards
// carry no compliance split. Hidden entirely by the parent when none apply.
const NotMeasuredStrip = ({ regulations }) => (
    <Box sx={{ mt: '14px', pt: '14px', borderTop: '1px solid #EBEDF8' }}>
        <Box
            sx={{
                fontSize: '11px',
                fontWeight: 700,
                letterSpacing: '0.7px',
                textTransform: 'uppercase',
                color: 'text.secondary',
                mb: '10px',
            }}
        >
            Not measured against obligations
        </Box>
        <Box sx={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            {regulations.map((reg) => (
                <Box
                    key={reg.key}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        p: '12px 14px',
                        border: '1px solid #EBEDF8',
                        borderRadius: '4px',
                        minWidth: '320px',
                    }}
                >
                    <Box sx={{ width: '4px', height: '30px', borderRadius: '2px', flexShrink: 0, backgroundColor: reg.color }} />
                    <Box>
                        <Box sx={{ fontSize: '14px', fontWeight: 600, color: 'text.primary' }}>{reg.name}</Box>
                        <Box sx={{ fontSize: '13px', color: 'text.primary', mt: '1px' }}>{reg.reason}</Box>
                        <Box sx={{ fontSize: '12px', color: 'text.secondary' }}>
                            {`${reg.assetCount.toLocaleString()} assets · ${reg.category}`}
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    </Box>
);

export default NotMeasuredStrip;
